<template>
  <div class="index">
    <div class="list">
      <!-- <div class="item">
        <div class="row">
          <div class="tel">
            联系电话
          </div>
          <div class="tel2">
            {{ orderInfo.exchange_phone }}
          </div>
        </div>
        <div class="word">
          请联系客服获得退货邮寄地址
        </div>
      </div> -->
      <div class="item">
        <div class="tel">寄回货品物流信息填写</div>
        <div class="row">
          <div class="tel2">
            物流订单号
          </div>
          <div class="tel2">
            <input
              type="text"
              placeholder="请在这里输入物流订单号"
              v-model="delivery_id"
            />
          </div>
        </div>
        <div class="row">
          <div class="tel2">
            物流公司
          </div>
          <div class="tel3" @click="wuliua()" v-if="delivery_name">
            {{ delivery_name }}
          </div>
          <div class="tel3" @click="wuliua()" v-else>
            请选择物流公司
          </div>
          <div class="tel2" @click="wuliua()">
            >
          </div>
        </div>
      </div>
      <!-- <div class="item" @click="addressTap"> -->
      <div class="item">
        <div class="row2">
          <div class="tel">商家收货地址</div>
          <div class="tel">></div>
        </div>

        <div class="row">
          <div class="tel2">
            收货人：
          </div>
          <div class="tel2">
            {{ orderInfo.exchange_name }}
          </div>
          <div class="tel3">
            {{ orderInfo.exchange_phone }}
          </div>
        </div>
        <div class="row">
          <div class="tel2">
            收货地址：
          </div>
          <div class="tel3">
            {{ orderInfo.exchange_address }}
          </div>
        </div>
      </div>
      <!-- <div class="item">
        <div class="tel">换货说明</div>
        <div class="row">
          <textarea
            placeholder="请在这里输入您的换货说明"
            v-model="apply_remark"
          ></textarea>
        </div>
      </div> -->
    </div>
    <div class="btn">
      <div class="btnsure" @click="apply()">
        提交申请
      </div>
    </div>
    <div class="wuliu" v-if="wuliushow">
      <div class="wuliucon">
        <div class="wuliutop">
          <div class="" @click="wuliushow = false">
            取消
          </div>
          <div class="" @click="wuliushow = false">
            确定
          </div>
        </div>
        <div class="wuliulist">
          <div
            :class="[tabIndex == index ? 'active' : '', 'wuliuitem']"
            v-for="(item, index) in wuliu"
            :key="index"
            @click="changewuliu(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>

<script>
import AddressWindow from "@components/AddressWindow";
import { getLogistics } from "@api/public";
import { recedeInfo, orderReturns } from "@api/order";
export default {
  name: "refund",
  components: {
    AddressWindow
  },
  data() {
    return {
      parameter: {
        navbar: "1",
        return: "1",
        title: "换货信息填写",
        color: true,
        class: "red"
      },
      wuliu: [],
      tabIndex: -1,
      wuliushow: false,
      showAddress: false,
      addressLoaded: false,
      addressInfo: {},
      delivery_id: "",
      // apply_remark: "",
      delivery_name: "",
      orderInfo: {}
    };
  },
  methods: {
    changewuliu(index) {
      this.tabIndex = index;
      console.log(index);
      this.delivery_name = this.wuliu[index].name;
    },
    wuliua() {
      this.wuliushow = true;
      getLogistics().then(res => {
        console.log(res);
        this.wuliu = res.data;
      });
    },
    //选择地址
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      console.log(this.addressInfo);
    },
    apply() {
      let that = this;
      if (this.delivery_id == "" || this.delivery_id == null) {
        return this.$dialog.toast({ mes: "请输入物流单号" });
      }
      if (this.delivery_name == "" || this.delivery_name == null) {
        return this.$dialog.toast({ mes: "请输入物流公司名称" });
      }
      // if (this.apply_remark == "" || this.apply_remark == null) {
      //   return this.$dialog.toast({ mes: "请输换货备注" });
      // }
      recedeInfo({
        id: this.$route.query.id,
        delivery_id: this.delivery_id,
        delivery_name: this.delivery_name
        // ,apply_remark: this.apply_remark
      })
        .then(res => {
          that.$dialog.toast({ mes: res.msg });
          this.$router.replace({
            path: "/recede/recededetails",
            query: { id: this.$route.query.id }
          });
        })
        .catch(err => {
          console.log(333);
          that.$dialog.error(err.msg);
          this.$router.replace({
            path: "/recede/recededetails",
            query: { id: this.$route.query.id }
          });
        });
    }
  },
  mounted() {
    orderReturns({ id: this.$route.query.id }).then(res => {
      this.orderInfo = res.data;
    });
  }
};
</script>
<style scoped="scoped">
.index {
  background-color: #f4f4f4;
  position: absolute;
  top: 0;
  bottom: 0;
}

.list {
  width: 100%;
  height: auto;
  padding: 15px;
  box-sizing: border-box;
}

.item {
  width: 100%;
  min-height: 100px;
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 20px 15px;
  box-sizing: border-box;
}

.row {
  width: 100%;
  /* height: 30px; */
  line-height: 30px;
  display: flex;
}

.tel {
  font-size: 15px;
  color: #000000;
  font-weight: bold;
  margin-right: 15px;
  line-height: 30px;
}

.tel2 {
  font-size: 13px;
}

.tel2 input {
  margin-left: 15px;
  margin-top: 7px;
  font-size: 12px;
  width: 200px;
}

.word {
  color: #333333;
  font-size: 12px;
  line-height: 25px;
}
.title {
  font-size: 15px;
  font-weight: ;
}
.row2 {
  display: flex;
  justify-content: space-between;
}
.tel3 {
  margin: 0 15px;
  margin-left: 21px;
  width: 50%;
}
.btn {
  width: 100%;
  height: 40px;
  position: fixed;
  bottom: 15px;
  padding: 0 15px;
  box-sizing: border-box;
}

.btnsure {
  width: 100%;
  height: 40px;
  font-size: 15px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  background-color: #e02d26;
  border-radius: 10px;
}
.wuliu {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99;
}
.wuliucon {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: auto;
  background-color: #fff;
}
.wuliutop {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.wuliulist {
  width: 100%;
  height: auto;
}
.wuliuitem {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  border-top: #f2f2f2 solid 1px;
}
.wuliuitem.active {
  color: #ff0000;
}
.row textarea {
  font-size: 12px;
  width: 100%;
  height: 50px;
}
</style>
